import qs from 'qs'
import apiError from './apierror'

export default function (reqInfo) {
  var reqName = reqInfo.reqName
  var reqData = reqInfo.reqData
  var reqConfig = reqInfo.reqConfig
  var reqAttrs = reqConfig.attrs || {
    withCredentials: true,
  }

  window.eeoDynamicHost = window.EEOENV.hosts.api
  var lang = window.browserVersion.language

  const host = 'https://' + window.eeoDynamicHost
  console.log('---lang---', lang)
  return axios({
    url: reqConfig.url,
    method: reqConfig.method || 'post',
    baseURL: reqConfig.host || host,
    responseType: 'text',
    ...reqAttrs,
    data: qs.stringify(reqConfig.data(reqData)),
    headers: {
      /*
        需求地址: https://www.tapd.cn/45976096/prong/stories/view/1145976096001045407
        提前找运维配置Access-Control-Allow-Headers
      */
      'X-EEO-CLIENT-LANGUAGE': lang,
    },
    transformResponse: [
      function (res) {
        var jsonObj = false
        try {
          jsonObj = JSON.parse(res)
        } catch (res) {
          alert(res.error_info.error)
        }
        if (jsonObj) {
          return reqConfig.transformResponse(jsonObj)
        } else {
          return false
        }
      },
    ],
  })
}
